import { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { SiteContext } from "../contexts/SiteContext";
import { useAuth } from "../admin/contexts/AuthContext";
import { Grid, makeStyles } from "@material-ui/core";
import Header from "../components/Header";
import AppBar from "../components/AppBar";
import WhatIs from "../components/WhatIs";
import Units from "../components/Units";
import Themes from "../components/Themes";
import Regions from "../components/Regions";
import Warning from "../components/Warning";
import Spotlight from "../components/Spotlight";
import Breadcrumbs from "../components/Breadcrumbs";
import NotFound from "../components/NotFound";
import Loading from "../components/Loading";
import AdminBar from "../components/AdminBar";
import Banner from "../components/Banner";
import NotAllowed from "../components/NotAllowed";

import fetchSite from "../utils/fetchSite";

const useStyles = makeStyles((theme) => ({
  main: {
    padding: "1rem",
    paddingTop: 0,
    margin: "0 auto",
    maxWidth: process.env.REACT_APP_MAX_WIDTH,
  },
}));

function Home() {
  const { isAuth } = useAuth();
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const { selectedSite, setSelectedSite } = useContext(SiteContext);
  const { siteSlug } = useParams();

  useEffect(() => {
    fetchSite(siteSlug, setSelectedSite, setLoading);
  }, [siteSlug, setSelectedSite]);

  if (loading) {
    return <Loading />;
  }

  if (!loading && !selectedSite) {
    return <NotFound />;
  }

  // Do not display if the site isn't published and the user isn't logged in
  if (!isAuth && !selectedSite.published) {
    return <NotAllowed />;
  }

  return (
    <>
      <AdminBar />
      <Header />
      <AppBar />

      <Banner />

      <Breadcrumbs />
      <main className={classes.main}>
        <Grid className={classes.row} container spacing={3}>
          <Grid item xs={12} md={4}>
            <WhatIs />
            <Warning margin="1rem 0" />
            <Spotlight />
          </Grid>
          <Grid item xs={12} md={8}>
            <Units />
            <Themes />
            <Regions />
          </Grid>
        </Grid>
      </main>
    </>
  );
}

export default Home;
